var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgCircleArrowRight = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "circle-arrow-right_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Rectangle 36",
  fill: "currentColor",
  d: "M0 0h24v24H0z"
})))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 13706",
  clipPath: "url(#circle-arrow-right_svg__a)",
  fill: "currentColor"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 79",
  d: "M18.293 11.854a1.111 1.111 0 0 0-.037-.172 1.124 1.124 0 0 0-.3-.488l-3.487-3.237a1.125 1.125 0 1 0-1.531 1.649l1.387 1.287H6.821a1.125 1.125 0 1 0 0 2.25h7.491l-1.387 1.287a1.125 1.125 0 1 0 1.531 1.649l3.483-3.232a1.118 1.118 0 0 0 .277-.395.407.407 0 0 0 .018-.044 1.119 1.119 0 0 0 .056-.53"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 80",
  d: "M12 0a12 12 0 1 0 12 12A12.014 12.014 0 0 0 12 0m0 21.75A9.75 9.75 0 1 1 21.75 12 9.761 9.761 0 0 1 12 21.75"
}))));
export default SvgCircleArrowRight;